import { IAdminTimesheetsFilters, IAppUsageFilters } from "src/app/modules/logged/dashboard/store/types";

export class SetAdminTimesheetsFilters {
    static readonly type = '[dashboard] set admin timesheets filters';
    constructor(public filters?: IAdminTimesheetsFilters) { }
}
export class SetMoreInfo {
    static readonly type = '[dashboard] set more info';
    constructor(public value: boolean) { }
}

export class FetchCompanyTimesheets {
    static readonly type = '[dashboard] fetch company timesheets';
    constructor(public companyID: string) { }
}

export class FetchMoreCompanyTimesheets {
    static readonly type = '[dashboard] fetch more company timesheets';
    constructor(public companyID: string) { }
}

export class ChangeTimesheetStatus {
    static readonly type = '[dashboard] change timesheet status';
    constructor(public companyID: string, public payrollID: string, public status: string) { }
}

export class SetAppUsageFilters {
    static readonly type = '[dashboard] set app usage filters';
    constructor(public filters?: IAppUsageFilters) { }
}

export class SetSearchField {
    static readonly type = '[dashboard] set search field';
    constructor(public value: string) { }
}
